import React, { useContext, useEffect, useState } from "react"
import { useAppContext } from "../../helpers/appContext"
import { sbAssetType } from "../../types"
import {
    StyledIcon,
    StyledMedia,
    StyledMediaImg,
    StyledMediaVideo,
    StyledExternal,
} from "./partials"
import Image360 from "../../assets/images/360-icon.svg"
import ImagePlay from "../../assets/images/play.svg"
import YouTube, { YouTubeProps } from "react-youtube"


export interface MediaProps {
    media: sbAssetType
    aspect_ratio: string
    video_controls: boolean
    video_loop: boolean
    video_autoplay: boolean
    video_muted: boolean
    video_url: string
    external_video: string
    youvisit_url: string
    mobile_image: sbAssetType
    mobile_aspect_ratio: string
    play_at_current_size: boolean
}

const MediaCmp: React.FC<MediaProps> = ({
    media,
    aspect_ratio,
    video_controls,
    video_loop,
    video_autoplay,
    video_muted,
    video_url,
    external_video,
    youvisit_url,
    mobile_image,
    mobile_aspect_ratio,
    play_at_current_size,
}) => {

    const { state, dispatch } = useAppContext();
    const [showCurrentSizeVideo, setShowCurrentSizeVideo] = useState(false)
    const postscribe = typeof window !== "undefined" ? require("postscribe") : null

    useEffect(() => {
        if (postscribe) {
            postscribe(
                document.body,
                `<script
        async="async"
        defer="defer"
        src="https://www.youvisit.com/tour/Embed/js3"
      ></script>`
            )
        } 
    }, [])

    useEffect(() => {
        dispatch({
            type: 'UPDATE_CATALOG_INFO',
            payload: {
                Video: {
                    id: media.id ? media.id.toString() : "",
                    name: "",
                    url: video_url ? video_url : external_video,
                },
            },
        });
    }, [])

    const onPlayerReady: YouTubeProps['onReady'] = (event) => {
        event.target.mute();
        event.target.playVideo();
    }

    function openVideo(video: string) {
        dispatch({
            type: 'MODAL',
            payload: {
                overlay_open: true,
                overlay_video_url: video,
            },
        });
        
        let updatedCatalog = { ...state.catalogInfo.Video };

        if (state.catalogInfo.Campus.id) {
            updatedCatalog.relatedCatalogObjects = {
                ...updatedCatalog.relatedCatalogObjects,
                Campus: [state.catalogInfo.Campus.id],
            };
        }
    
        if (state.catalogInfo.Degree.id) {
            updatedCatalog.relatedCatalogObjects = {
                ...updatedCatalog.relatedCatalogObjects,
                Degree: [state.catalogInfo.Degree.id],
            };
        }

        if (state.catalogInfo.Program.id) {
            updatedCatalog.relatedCatalogObjects = {
                ...updatedCatalog.relatedCatalogObjects,
                Program: [state.catalogInfo.Program.id],
            };
        }

        if (state.catalogInfo.Form.id) {
            updatedCatalog.relatedCatalogObjects = {
                ...updatedCatalog.relatedCatalogObjects,
                Form: [state.catalogInfo.Form.id],
            };
        }

        if (state.catalogInfo.Tags) {
            updatedCatalog.relatedCatalogObjects = {
                ...updatedCatalog.relatedCatalogObjects,
                Tags: state.catalogInfo.Tags,
            };
        }
    
        dispatch({
            type: 'UPDATE_PAGE_INFO',
            payload: {
                catalog: {
                    Video: updatedCatalog,
                },
            },
        });

        document && document.body.classList.add("g--no-scroll-v2")
    }

    function openVideoCurrentSize() {
        setShowCurrentSizeVideo(!showCurrentSizeVideo)
    }

    // EXTERNAL AND YOUTUBE URL
    if ((video_url || external_video)) {
        return (
            showCurrentSizeVideo ? (
                <StyledExternal data-name="video" data-video-url={video_url ? video_url : external_video}>
                    {video_url ? (
                        <YouTube
                            videoId={video_url.substr(-11)}
                            onReady={onPlayerReady}
                        />
                    ) : (
                        <YouTube
                            videoId={external_video.substr(-11)}
                            onReady={onPlayerReady}
                        />
                    )}
                </StyledExternal>
            ) : (
                <StyledMedia data-name="video" data-video-url={video_url ? video_url : external_video} onClick={play_at_current_size ? () => openVideoCurrentSize() : () => openVideo(video_url ? video_url : external_video)}>
                    <StyledIcon>
                        <img src={ImagePlay} />
                        <p>PLAY VIDEO</p>
                    </StyledIcon>
                    {mobile_image && mobile_image.id !== null && (
                        <StyledMediaImg
                            data-name="image"
                            mobile_aspect_ratio={mobile_aspect_ratio}
                            mobile={true}
                            className="lazyload"
                            data-src={mobile_image.filename.replace(
                                "a.storyblok.com",
                                "img2.storyblok.com"
                            )}
                            alt={mobile_image.alt}
                            title={mobile_image.title}
                        />
                    )}
                    {media && media.id !== null && (
                        <StyledMediaImg
                            data-name="image"
                            aspect_ratio={aspect_ratio}
                            mobile={false}
                            has_mobile_alt={mobile_image && mobile_image.id !== null}
                            className="lazyload"
                            data-src={media.filename.replace(
                                "a.storyblok.com",
                                "img2.storyblok.com"
                            )}
                            alt={media.alt}
                            title={media.title}
                        />
                    )}
                </StyledMedia>
            )
        )
    }
    // YOUVISIT
    else if (youvisit_url) {
        return (
            <StyledMedia
            >
                <a
                    href={`https://www.youvisit.com/#/vte/?${youvisit_url}`}
                >
                    <StyledIcon>
                        <img src={Image360} />
                        <p>VIRTUAL TOUR</p>
                    </StyledIcon>
                </a>
                {mobile_image && mobile_image.id !== null && (
                    <StyledMediaImg
                        data-name="image"
                        mobile_aspect_ratio={mobile_aspect_ratio}
                        mobile={true}
                        className="lazyload"
                        data-src={mobile_image.filename.replace(
                            "a.storyblok.com",
                            "img2.storyblok.com"
                        )}
                        alt={mobile_image.alt}
                        title={mobile_image.title}
                    />
                )}
                {media && media.id !== null && (
                    <StyledMediaImg
                        data-name="image"
                        aspect_ratio={aspect_ratio}
                        mobile={false}
                        has_mobile_alt={mobile_image && mobile_image.id !== null}
                        className="lazyload"
                        data-src={media.filename.replace(
                            "a.storyblok.com",
                            "img2.storyblok.com"
                        )}
                        alt={media.alt}
                        title={media.title}
                    />
                )}
            </StyledMedia>
        )
    }
    else {
        return (
            <StyledMedia
            >
                {mobile_image && mobile_image.id !== null && (
                    <>
                        {mobile_image.filename.endsWith(".mp4") ? (
                            <StyledMediaVideo
                                data-name="video"
                                data-video-url={mobile_image.filename}
                                controls={video_controls}
                                loop={video_loop}
                                autoPlay={video_autoplay}
                                muted={video_muted}
                                mobile={true}
                            >
                                <source src={mobile_image.filename} type="video/mp4" />
                            </StyledMediaVideo>
                        ) : (
                            <StyledMediaImg
                                data-name="image"
                                mobile_aspect_ratio={mobile_aspect_ratio}
                                mobile={true}
                                className="lazyload"
                                data-src={mobile_image.filename.replace(
                                    "a.storyblok.com",
                                    "img2.storyblok.com"
                                )}
                                alt={mobile_image.alt}
                                title={mobile_image.title}
                            />
                        )}
                    </>
                )}
                {media && media.id !== null && (
                    <>
                        {media.id !== null && media.filename.endsWith(".mp4") ? (
                            <StyledMediaVideo
                                data-name="video_mp4"
                                data-video-url={media.filename}
                                controls={video_controls}
                                loop={video_loop}
                                autoPlay={video_autoplay}
                                muted={video_muted}
                                mobile={false}
                                has_mobile_alt={mobile_image && mobile_image.id !== null}
                            >
                                <source src={media.filename} type="video/mp4" />
                            </StyledMediaVideo>
                        ) : (
                            <StyledMediaImg
                                data-name="image"
                                aspect_ratio={aspect_ratio}
                                mobile={false}
                                has_mobile_alt={mobile_image && mobile_image.id !== null}
                                className="lazyload"
                                data-src={media.filename.replace(
                                    "a.storyblok.com",
                                    "img2.storyblok.com"
                                )}
                                alt={media.alt}
                                title={media.title}
                            />
                        )}
                    </>
                )}
            </StyledMedia>
        )
    }
}

export default MediaCmp
